import { translations as PageHeaderTranslations } from 'components/page/i18n/locales/it/translations';
import { translations as CampaignTranslations } from 'containers/Campaign/i18n/locales/it/translations';
import { translations } from 'containers/Customer/i18n/locales/it/translations';
import { translations as RewardItTranslation } from 'containers/Reward/i18n/locales/it/translations';
import { translations as RuleTranslations } from 'containers/Rule/i18n/locales/it/translations';
import { translations as GlobalTranslations } from 'utils/globalTranslation/locales/it/translations';
import {
  CampaignModule,
  CustomerModule,
  PageHeaderModule,
  RewardModule,
  RuleModule,
  GlobalModule
} from 'utils/i18n/TModules';

export const globalTranslations = {
  [CustomerModule]: translations,
  [RewardModule]: RewardItTranslation,
  [CampaignModule]: CampaignTranslations,
  [PageHeaderModule]: PageHeaderTranslations,
  [RuleModule]: RuleTranslations,
  [GlobalModule]: GlobalTranslations
};
